
import emailList from './emailList';
import emailSave from './emailSave';
import emailUpdate from './emailUpdate';
import emailDelete from './emailDelete';
export default {
    emailList,
    emailSave,
    emailUpdate,
    emailDelete,
}


// WEBPACK FOOTER //
// ./src/api/collection/index.ts